export default __webpack_public_path__ + "static/media/nfo-banner-finance-comp-mobile.f2b1f117.jpg";